const register = {
  EN: {
    title: 'REGISTER',
    paragraph1: 'General Information',
    placeholder_firstname: 'First name',
    placeholder_lastname: 'Last name',
    placeholder_email: 'Email',
    paragraph2: 'Create password for use systems',
    placeholder_password: 'Password',
    require_password:
      'Use 6 or more characters consisting of uppercase letters, lowercase letters, numbers and symbol.',
    placeholder_confirm: 'Confirm password',
    accept_condition: 'By registering, I accept',
    term_condition: 'Term and Condition',
    regis_button: 'Next',
    or: 'OR',
    regis_button_Google: 'Register in with Google',
    regis_button_Facebook: 'Register in with Facebook',
    have_account: 'Already a member?',
    to_login: 'Log in here',
    firstname_required: 'Please enter your first name',
    lastname_required: 'Please enter your last name',
    email_required: 'Please enter your email',
    email_invalid: 'Invalid email',
    email_alreadyexist: 'This email is already exist',
    phone_required: 'Please enter your phone number',
    phone_invalid: 'Invalid phone number',
    phone_alreadyexist: 'This phone number is already exist',
    password_required: 'Please create password',
    passcode_required: 'Please create passcode',
    password_min: 'Password must be at least 6 characters',
    passcode_min: 'Password must be 6 characters only',
    confirmPassword_required: 'Please confirm password',
    confirmPasscode_required: 'Please confirm passcode',
    confirmpass_notmatch: 'Confirm password is not match',
    confirmpasscode_notmatch: 'Confirm passcode is not match',
    passcode_notmatch: ' passcode is not match',
    validate_password: 'Must have uppercase letters, lowercase letters, numbers and symbol',
  },
  TH: {
    title: 'สมัครสมาชิก',
    paragraph1: 'ข้อมูลทั่วไป',
    placeholder_firstname: 'ชื่อ',
    placeholder_lastname: 'นามสกุล',
    placeholder_email: 'อีเมล',
    paragraph2: 'สร้างรหัสผ่านสำหรับเข้าสู่ระบบ',
    placeholder_password: 'รหัสผ่าน',
    require_password:
      'รหัสผ่าน 6 ตัวขึ้นไป และต้องประกอบไปด้วย ตัวพิมพ์ใหญ่, ตัวพิมพ์เล็ก, ตัวเลข และ สัญลักษณ์อย่างน้อย 1 ตัว',
    placeholder_confirm: 'ยืนยันรหัสผ่าน',
    accept_condition: 'ฉันยอมรับ',
    term_condition: 'ข้อตกลงและเงื่อนไขการให้บริการ',
    regis_button: 'ต่อไป',
    or: 'หรือ',
    regis_button_Google: 'สมัครสมาชิกด้วยกูเกิ้ล',
    regis_button_Facebook: 'สมัครสมาชิกด้วยเฟซบุ๊ก',
    have_account: 'มีบัญชีอยู่แล้วใช่หรือไม่?',
    to_login: 'เข้าสู่ระบบ',
    firstname_required: 'กรุณากรอกชื่อ',
    lastname_required: 'กรุณากรอกนามสกุล',
    email_required: 'กรุณากรอกอีเมล',
    email_invalid: 'อีเมลไม่ถูกต้อง',
    email_alreadyexist: 'อีเมลนี้ถูกใช้งานไปแล้ว',
    phone_required: 'กรุณากรอกหมายเลขโทรศัพท์',
    phone_invalid: 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
    phone_alreadyexist: 'หมายเลขโทรศัพท์นี้ถูกใช้งานไปแล้ว',
    password_required: 'กรุณากรอกรหัสผ่าน',
    passcode_required: 'กรุณากรอกรหัสผ่าน',
    passcode_notmatch: ' กรุณากรอก passcode',
    password_min: 'รหัสผ่านต้องมีความยาวไม่น้อยกว่า 6 ตัวอักษร ',
    passcode_min: 'passcode ต้องมีความยาว 6 ตัวอักษร เท่านั้น',
    confirmPassword_required: 'กรุณายืนยันรหัสผ่าน',
    confirmPasscode_required: 'กรุณายืนยัน passcode',
    confirmpass_notmatch: 'ยืนยันรหัสผ่านไม่ถูกต้อง',
    confirmpasscode_notmatch: 'ยืนยันรหัส passcode ไม่ถูกต้อง',
    validate_password:
      'ต้องมี ตัวพิมพ์ใหญ่, ตัวพิมพ์เล็ก, ตัวเลข และ สัญลักษณ์อย่างน้อยอย่างละ 1 ตัว',
  },
};

export default register;
